export const krnWorks = {
  commercial: [
    {
      id: 1,
      title: '[ABC마트] 블루 ABC데이 편',
      year: '',
    },
    {
      id: 2,
      title: '[에이지앤씨모빌리티] 전동칫솔 광고',
      year: '',
    },
  ],
  mv: [
    {
      id: 1,
      title: 'HarryIM - 첫사랑 (여자 주인공역)',
      year: '',
    },
  ],
};
